// Zabawy dla myszki: karty przechylają się w 3D z odblaskiem, przyciski są „magnetyczne” i sprężynują,
// podświetlenie w menu przeskakuje za kursorem, logo szczeka, a po hero biegają ślady łapek.
import {gsap, $$, PAW_SVG} from "./shared";

export function initInteractions() {
    initTilt();
    initMagnetic();
    initMenuBlob();
    initWoof();
    initPawTrail();
    initWag();
}

function initTilt() {
    $$(".cc-dog, .cc-puppy, .cc-plan, .cc-feature, .cc-litter, .cc-contact").forEach((card) => {
        card.classList.add("cc-glare");
        gsap.set(card, {transformPerspective: 900});
        const rx = gsap.quickTo(card, "rotationX", {duration: 0.5, ease: "power3"});
        const ry = gsap.quickTo(card, "rotationY", {duration: 0.5, ease: "power3"});
        card.addEventListener("pointermove", (event) => {
            const r = card.getBoundingClientRect();
            const px = (event.clientX - r.left) / r.width;
            const py = (event.clientY - r.top) / r.height;
            const power = Math.min(1, 420 / r.width); // szerokie karty przechylają się mniej
            ry((px - 0.5) * 12 * power);
            rx((0.5 - py) * 10 * power);
            card.style.setProperty("--gx", `${(px * 100).toFixed(1)}%`);
            card.style.setProperty("--gy", `${(py * 100).toFixed(1)}%`);
            card.style.setProperty("--glare", "1");
        });
        card.addEventListener("pointerleave", () => {
            rx(0);
            ry(0);
            card.style.setProperty("--glare", "0");
        });
    });
}

function initMagnetic() {
    $$(".cc-btn:not(.cc-btn--ghost), .cc-header__toggle").forEach((btn) => {
        const xTo = gsap.quickTo(btn, "x", {duration: 0.4, ease: "power3"});
        const yTo = gsap.quickTo(btn, "y", {duration: 0.4, ease: "power3"});
        const clamp = gsap.utils.clamp(-12, 12);
        btn.addEventListener("pointermove", (event) => {
            const r = btn.getBoundingClientRect();
            xTo(clamp((event.clientX - (r.left + r.width / 2)) * 0.3));
            yTo(clamp((event.clientY - (r.top + r.height / 2)) * 0.4));
        });
        btn.addEventListener("pointerleave", () => {
            xTo(0);
            yTo(0);
        });
        // Wciśnięcie: galaretka, która odbija z powrotem.
        btn.addEventListener("pointerdown", () => gsap.to(btn, {scaleX: 1.08, scaleY: 0.9, duration: 0.12, ease: "power2.out", overwrite: "auto"}));
        const release = () => gsap.to(btn, {scaleX: 1, scaleY: 1, duration: 0.7, ease: "elastic.out(1.1, 0.3)", overwrite: "auto"});
        btn.addEventListener("pointerup", release);
        btn.addEventListener("pointercancel", release);
        btn.addEventListener("pointerleave", release);
    });
}

function initMenuBlob() {
    const menu = document.querySelector(".cc-header .cc-menu");
    if (!menu) {
        return;
    }
    const desktop = window.matchMedia("(min-width: 1120px)");
    menu.classList.add("has-blob");
    gsap.set(menu, {"--blob-x": "0px", "--blob-w": "0px", "--blob-o": 0});

    const move = (link) => {
        if (!desktop.matches) {
            return;
        }
        const m = menu.getBoundingClientRect();
        const l = link.getBoundingClientRect();
        const to = {"--blob-x": `${l.left - m.left}px`, "--blob-w": `${l.width}px`};
        if (gsap.getProperty(menu, "--blob-o") < 0.1) {
            gsap.set(menu, to); // pojawia się od razu pod kursorem, a potem już przeskakuje
        }
        gsap.to(menu, {...to, "--blob-o": 1, duration: 0.6, ease: "elastic.out(1, 0.7)", overwrite: "auto"});
    };
    menu.addEventListener("pointerover", (event) => {
        const link = event.target.closest(".cc-menu__link");
        if (link) {
            move(link);
        }
    });
    menu.addEventListener("focusin", (event) => {
        const link = event.target.closest(".cc-menu__link");
        if (link) {
            move(link);
        }
    });
    const hide = () => gsap.to(menu, {"--blob-o": 0, duration: 0.3, overwrite: "auto"});
    menu.addEventListener("pointerleave", hide);
    menu.addEventListener("focusout", (event) => {
        if (!menu.contains(event.relatedTarget)) {
            hide();
        }
    });
}

function initWoof() {
    const logo = document.querySelector(".cc-header__logo");
    const img = logo?.querySelector("img");
    if (!logo || !img) {
        return;
    }
    const bubble = document.createElement("span");
    bubble.className = "cc-woof";
    bubble.setAttribute("aria-hidden", "true");
    logo.appendChild(bubble);
    const words = ["Hau!", "Hau hau!", "Wuf!", "Hau? Hau!"];
    let busy = false;
    let n = 0;
    logo.addEventListener("pointerenter", () => {
        if (busy) {
            return;
        }
        busy = true;
        bubble.textContent = words[n++ % words.length];
        gsap.timeline({onComplete: () => {
            busy = false;
        }})
            .to(img, {rotation: 7, duration: 0.8, ease: "cc-wiggle"}, 0)
            .fromTo(bubble, {autoAlpha: 0, scale: 0, rotation: -25, y: 6}, {autoAlpha: 1, scale: 1, rotation: -6, y: 0, duration: 0.55, ease: "back.out(3)"}, 0.05)
            .to(bubble, {autoAlpha: 0, y: -14, duration: 0.3, ease: "power1.in"}, 1.5);
    });
}

function initPawTrail() {
    $$(".cc-hero, .cc-profile").forEach((area) => {
        let last = null;
        let left = false;
        let alive = 0;
        area.addEventListener("pointermove", (event) => {
            if (event.pointerType !== "mouse") {
                return;
            }
            const r = area.getBoundingClientRect();
            const x = event.clientX - r.left;
            const y = event.clientY - r.top;
            if (last && Math.hypot(x - last.x, y - last.y) < 70) {
                return;
            }
            const angle = last ? Math.atan2(y - last.y, x - last.x) * 180 / Math.PI + 90 : 0;
            last = {x, y};
            if (alive > 14) {
                return;
            }
            left = !left;
            const side = ((left ? 1 : -1) * 10);
            const rad = angle * Math.PI / 180;
            const print = document.createElement("span");
            print.className = "cc-pawprint";
            print.innerHTML = PAW_SVG;
            print.style.left = `${x + Math.cos(rad) * side}px`;
            print.style.top = `${y + Math.sin(rad) * side}px`;
            area.appendChild(print);
            alive += 1;
            gsap.timeline({onComplete: () => {
                print.remove();
                alive -= 1;
            }})
                .fromTo(print, {scale: 0, rotation: angle, autoAlpha: 0}, {scale: 1, autoAlpha: 0.6, duration: 0.25, ease: "back.out(3)"})
                .to(print, {scale: 0.6, autoAlpha: 0, duration: 0.8, ease: "power1.in"}, "+=0.5");
        });
    });
}

function initWag() {
    // Szczeniak merda całą kartą.
    $$(".cc-puppy").forEach((card) => {
        card.addEventListener("pointerenter", () => gsap.fromTo(card, {rotation: 0}, {rotation: 2.5, duration: 0.8, ease: "cc-wag", overwrite: "auto"}));
    });
}
